import { getPadraoComRetorno, postPadraoComRetorno } from 'services/api';
import { duckDadosContribuinteLogado } from 'store/ducks/dadosCadastrais';

export const fetchGetDadosCadastrais = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(getPadraoComRetorno('Pessoa'))
      .then(res => {
        dispatch(duckDadosContribuinteLogado(res));
        resolve(res);
      })
      .catch(erro => reject(erro));
  });
};

export const fetchSalvarDadosCadastrais = dadosRequest => dispatch => {
  return new Promise((resolve, reject) => {
    const url = `Pessoa`;
    dispatch(postPadraoComRetorno(url, dadosRequest))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};
